import type { QuantityUnit } from '@luminovo/api-contracts';
import { QuantityHelper } from '@luminovo/commons';
import { transEnum } from '@luminovo/frontend-utils';

import { QuantityTypeRecord } from '../i18n';

export { formatQuantity, formatQuantityUnit } from '@luminovo/data-stack';
export type { FormatQuantityOptions } from '@luminovo/data-stack';

export function groupQuantityUnitByType(unit: QuantityUnit): string {
    const type = QuantityHelper.fromQuantityUnitToQuantityType(unit);
    return transEnum(type, QuantityTypeRecord);
}
